// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2496":"3b53517f","4396":"3b53517f","8104":"3b53517f","9866":"3b53517f"}[chunkId] + ".chunk.css";
};